import { useState } from 'react';
import * as R from 'ramda';

import DeleteModal from '@atom/components/common/DeleteModal';
import EditSummaryModal from '@atom/components/common/workOrderDetail/workOrderSummary/EditSummaryModal';
import { Icon, Menu } from '@atom/mui';
import { DeleteIcon, EditIcon } from '@atom/mui/icons';
import { Summary } from '@atom/types/work';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './workInfo.module.css';

const { MenuItem } = Menu;

const styles = {
  icon: {
    marginRight: '0.5rem',
  },
};

export interface Props {
  summary: Summary;
  summaries: Summary[];
  index: number;
  updateSummary: (updatedSummary: Summary[]) => void;
}

const SummaryRow = ({ summary, summaries, index, updateSummary }: Props) => {
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

  const deleteSummary = () => {
    const updatedSummary = R.remove(index, 1, summaries);
    updateSummary(updatedSummary);
    setDeleteModalOpen(false);
  };

  const editSummary = (newSummary: Summary) => {
    const updatedSummary = summaries.map(
      (summaryItem: Summary, indexValue: number) =>
        indexValue === index ? newSummary : summaryItem,
    );
    updateSummary(updatedSummary);
  };

  return (
    <>
      <div className={classes.summaryItemHeader}>
        <div>{summary.title}</div>
        {hasRolePermissions(ROLE_SETS.INSPECTOR) && (
          <Menu
            IconButtonProps={{ style: { padding: 0 } }}
            dataCyLabel={`bulkCreateSummaryMenu-${summary.title}`}
          >
            <MenuItem
              onClick={() => setEditModalOpen(true)}
              data-cy={`bulkCreateSummaryEdit-${summary.title}`}
            >
              <Icon style={styles.icon} icon={EditIcon} />
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => setDeleteModalOpen(true)}
              data-cy={`bulkCreateSummaryDelete-${summary.title}`}
            >
              <Icon style={styles.icon} icon={DeleteIcon} />
              Delete
            </MenuItem>
          </Menu>
        )}
      </div>
      <div className={classes.summaryItemContent}>{summary.contents}</div>
      <DeleteModal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        onConfirm={() => deleteSummary()}
        title="Delete Section?"
        content={`Are you sure you want to delete the ${summary.title} section?`}
      />
      <EditSummaryModal
        open={editModalOpen}
        closeModal={() => setEditModalOpen(false)}
        summary={summary}
        editSummary={editSummary}
      />
    </>
  );
};

export default SummaryRow;
